document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('sizeChartModal');
  const btn = document.querySelector('.size-chart-button');
  const closeBtn = document.querySelector('.size-chart-close');
  const toggle = document.getElementById('unitSwitch');
  const label = document.querySelector('.switch-label');
  const tableCells = document.querySelectorAll('.details-content table td');

  // Return if required elements don't exist
  if (!modal || !btn) return;

  // Save original inch values only once
  tableCells.forEach((cell) => {
    let text = cell.textContent.trim();
    if (/^\d+(\.\d+)?(-\d+(\.\d+)?)?$/.test(text)) {
      cell.dataset.inch = text;
    }
  });

  // Render default (inch)
  tableCells.forEach((cell) => {
    if (cell.dataset.inch) {
      cell.textContent = cell.dataset.inch + ' in';
    }
  });

  if (label) {
    label.textContent = 'Inch';
  }

  // Open modal
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    modal.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  });

  // Close modal when clicking close button
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      modal.classList.remove('active');
      document.body.style.overflow = ''; // Restore scrolling
    });
  }

  // Close modal when clicking outside
  modal.addEventListener('click', function (e) {
    if (e.target === modal) {
      modal.classList.remove('active');
      document.body.style.overflow = ''; // Restore scrolling
    }
  });

  // Close modal on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      modal.classList.remove('active');
      document.body.style.overflow = ''; // Restore scrolling
    }
  });

  // Toggle unit conversion (Inch/CM)
  if (toggle) {
    toggle.addEventListener('change', function () {
      if (this.checked) {
        // Convert to CM
        if (label) label.textContent = 'CM';
        tableCells.forEach((cell) => {
          if (cell.dataset.inch) {
            let val = cell.dataset.inch;
            if (val.includes('-')) {
              // Handle range values like "32-34"
              let parts = val.split('-').map((v) => (parseFloat(v) * 2.54).toFixed(1));
              cell.textContent = parts.join('-') + ' cm';
            } else {
              // Handle single values
              cell.textContent = (parseFloat(val) * 2.54).toFixed(1) + ' cm';
            }
          }
        });
      } else {
        // Convert back to Inch
        if (label) label.textContent = 'Inch';
        tableCells.forEach((cell) => {
          if (cell.dataset.inch) {
            cell.textContent = cell.dataset.inch + ' in';
          }
        });
      }
    });
  }

  // Prevent modal content clicks from closing modal
  const modalContent = document.querySelector('.size-chart-modal-content');
  if (modalContent) {
    modalContent.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  }
});